<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">

                <div class="common-header-block">
                    <el-input
                            style="width: 400px"
                            placeholder="请输入玩家ID，多个用' , '分隔"
                            v-model="searchVal">
                        <el-select
                                slot="prepend"
                                style="width: 100px"
                                v-model="pattern"
                                placeholder="ID类型">
                            <el-option
                                    v-for="item in patternOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                </div>
            </div>
        </div>

        <div class="common-table">
            <el-table v-loading="loading" :data="userGps.beanList" :row-key="(row)=>row.userId+row.time" height="100%">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="玩家ID" align="center" prop="userId"/>
                <el-table-column label="GPS" align="center" prop="gps"/>
                <el-table-column label="IP" align="center" prop="ip"/>
                <el-table-column label="设备码" width="350" align="center" prop="imei"/>
                <el-table-column label="生成时间" align="center" prop="time"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="userGps.total"
                :current-page="currentPage"
                @current-change="getList({page:$event})"/>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                pattern: '0',
                patternOptions: [
                    {label: 'userID', value: '0'},
                    {label: '随机ID', value: '1'}
                ],
                searchVal: '',
                userGps: {// 玩家GPS
                    beanList: [],
                    total: 0
                },
                currentPage: 1
            }
        },
        methods: {
            ...mapActions('dataManage', ['getUserGps']),
            parameterCalibration() {
                if (!this.searchVal) {
                    this.$message.error('请输入俱乐部ID');
                    return false
                }
                return true
            },
            getList(obj = {}) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    userIdList: this.searchVal.split(','),
                    pattern: this.pattern,
                    page: 1,
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getUserGps(params).then(res => {
                    this.userGps = res.data;
                    this.loading = false;
                })
            },
        }
    }
</script>